import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0b0d6f4e&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/admin/header.scss?vue&type=style&index=0&id=0b0d6f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d6f4e",
  null
  
)

export default component.exports